// extracted by mini-css-extract-plugin
module.exports = {"img":"a10a3f92e9--img--3TCzB"};